import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DisplayItList from './display-it-list';
import ArrowButton from '../../../common/button-arrow';
import { getDisplayItObjectives } from '../../../../actions/display-it';
import PageTitle from '../../../common/page-title';

import './styles.css';

class DisplayIt extends Component {
  componentWillMount() {
    this.props.dispatch(getDisplayItObjectives());
  }

  render() {
    return (
      <div className='container-fluid display-it'>
        <Row>
          <PageTitle>Display It</PageTitle>
          <Row>
            <Col md={12}>
              <Link to='/admin/objectives/display-it/new'>
                <ArrowButton
                  color='red'
                  arrow={false}
                  submit={false}
                  className='add-display-it'
                >
                  ADD DISPLAY IT SUB OBJECTIVE
                </ArrowButton>
              </Link>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <DisplayItList
                displayIts={this.props.display_it_objectives}
                fetching={this.props.fetching}
                fetched={this.props.fetched}
                onPageChange={this.handlePageChange}
              />
            </Col>
          </Row>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  display_it_objectives: state.display_its.display_it_objectives,
  fetching: state.display_its.fetching,
  fetched: state.display_its.fetched,
});

export default connect(mapStateToProps)(DisplayIt);



// WEBPACK FOOTER //
// ./src/components/admin/objectives/display_it/index.jsx